import { resolveImageAltText } from '@/lib/utils';

export function renderWrappedImage(_attrs, _child, jsonBlock) {
  const entryData = jsonBlock.entryData;
  if (!entryData || !entryData.image?.url) {
    console.warn(
      'Wrapped image entry data is incomplete',
      jsonBlock?.uid ?? ''
    );
    return '';
  }

  let positionClass = '';
  if (entryData.position?.toLowerCase() === 'left') {
    positionClass = 'sm:float-left sm:mr-9';
  } else {
    positionClass = 'sm:float-right sm:ml-9';
  }
  return `
    <div 
      class="mx-auto sm:wrapped-image ${positionClass || ''} sm:max-w-[340px] my-6 bg-[${entryData.background_color_picker ? entryData.background_color_picker : 'dawn-grey-10'}]"
    >
      ${
        entryData.link?.href
          ? `
            <a href="${entryData.link.href}">
              <img 
                src="${entryData.image.url || 'default-image.jpg'}" 
                alt="${resolveImageAltText(entryData.image)}" 
                width="${entryData.image.dimension?.width || 300}" 
                height="${entryData.image.dimension?.height || 300}" 
                class="mb-3 bg-white hover:opacity-60 transition ease-in-out delay-100"
              />
            </a>
          `
          : `
            <img 
              src="${entryData.image.url || 'default-image.jpg'}" 
              alt="${resolveImageAltText(entryData.image)}" 
              width="${entryData.image.dimension?.width || 300}" 
              height="${entryData.image.dimension?.height || 300}" 
              class="mb-3"
        />`
      }
      <div class="px-3 py-4">
        <div class="body-r pr-1">
          ${entryData.caption || ''} ${
            entryData.link?.title && entryData.link?.href
              ? `
                <span class="pl-1">
                  <a href="${entryData.link.href}" class="hover:text-cozy-cognac sh11">
                    ${entryData.link.title}
                  </a>
                </span>
              `
              : ''
          }
        </div>
      </div>
    </div>
  `;
}
